// add a dot to the end of the text if it is missing
export const addDot = (text) => {
  const trimmedText = text.trim();

  return trimmedText.endsWith('.') ? trimmedText : `${trimmedText}.`;
}